import { AppRoute } from './@types/AppRoute';

export const getRoutes = async (): Promise<AppRoute[]> => {
    if (process.env.PUBLIC_ROUTE_FILE === 'MobileLocal') {
        return (await import(`./routesMobileLocal.ts`)).routes;
    } else if (process.env.PUBLIC_ROUTE_FILE === 'Mobile') {
        return (await import(`./routesMobile.ts`)).routes;
    } else if (process.env.PUBLIC_ROUTE_FILE === 'App') {
        return (await import(`./routesApp.ts`)).routes;
    } else if (process.env.PUBLIC_ROUTE_FILE === 'AppLocal') {
        return (await import(`./routesAppLocal.ts`)).routes;
    }

    throw new Error('Invalid route file');
};
